import { render, staticRenderFns } from "./EditModel3dTable.vue?vue&type=template&id=96447cd8&scoped=true"
import script from "./EditModel3dTable.ts?vue&type=script&lang=ts&external"
export * from "./EditModel3dTable.ts?vue&type=script&lang=ts&external"
import style0 from "./EditModel3dTable.vue?vue&type=style&index=0&id=96447cd8&prod&lang=scss"
import style1 from "./EditModel3dTable.vue?vue&type=style&index=1&id=96447cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96447cd8",
  null
  
)

export default component.exports